/*******************************************************************************
 * File: Header.js
 * Summary: Demo website header (across all pages)
 *******************************************************************************/

/*******************************************************************************
 * Section: Imports
 *******************************************************************************/

import iconLanguage from '../../assets/icon/language.svg'
import iconSearch from '../../assets/icon/search.svg'

import logoSita from '../../assets/img/logo-sita.png'
import styled from 'styled-components'

import LoggedInAccountHeader from './LoggedInAccountHeader'
import LoggedOutAccountHeader from './LoggedOutAccountHeader'

/*******************************************************************************
 * Section: Custom Divs
 *******************************************************************************/

const Logo = styled.img`
  width: 139px;
  :hover {
    cursor: pointer;
  }
`

const HeaderMenu = styled.menu`
  float: left;
  margin: 0 0 0 0px;
  padding: 0;
  font-size: 12px;
`

const HeaderUl = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

const HeaderLi = styled.li`
  float: left;
  :hover {
    text-decoration: underline;
  }
`
const NavBarButton = styled.button`
  background-color: Transparent;
  color: #ffffff;
  margin: 6px;
  border: none;

  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0%;
  vertical-alightment: middle;
  line-height: 100%;
`
const HeaderActions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
`

const HeaderIcons = styled.img`
  height: 17px;
`

const HeaderLanguageText = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;

  color: #ffffff;
  white-space: nowrap;
`

const AdminButton = styled.button`
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  background-color: transparent;
  color: #ffffff;
  padding: 0px 30px;
  border: 1px solid #ffffff;
  border-radius: 14px;
  height: 27px;
  cursor: pointer;
`

/*******************************************************************************
 * Function: Header
 * Summary: Renders Header across all pages for website
 ******************************************************************************/
function Header(props) {
  const HeaderDiv = styled.div`
    margin: 0 auto 0px;
    padding: 13px 0;
    width: 100%;
    height: 54px;
    background-color: ${props.backgroundColor};
    position: relative;

    /* Ensure child elements have full opacity */
    & * {
      opacity: 1;
    }
  `
  const HeaderContentWrapper = styled.div`
    width: 100%;
    max-width: 1375px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
  `

  return (
    <HeaderDiv>
      <HeaderContentWrapper>
        <Logo
          onClick={() => props.setPageState('home')}
          src={logoSita}
          alt="SITA Air"
        />
        <HeaderMenu>
          <HeaderUl>
            <HeaderLi>
              <NavBarButton>Explore</NavBarButton>
            </HeaderLi>
            <HeaderLi>
              <NavBarButton>Plan and Book</NavBarButton>
            </HeaderLi>
            <HeaderLi>
              <NavBarButton>Deals and Promos</NavBarButton>
            </HeaderLi>
            <HeaderLi>
              <NavBarButton>Before You Fly</NavBarButton>
            </HeaderLi>
            <HeaderLi>
              <NavBarButton>Need Help?</NavBarButton>
            </HeaderLi>
          </HeaderUl>
        </HeaderMenu>
        <>
          <HeaderActions>
            {props.loggedIn === false ? (
              <LoggedOutAccountHeader {...props} />
            ) : (
              <LoggedInAccountHeader {...props} />
            )}
            <AdminButton
              onClick={() => {
                if (props.adminAuthenticated) {
                  props.openAdminSettings()
                } else {
                  props.openAdminLogin()
                }
              }}
            >
              Admin
            </AdminButton>
            <HeaderIcons src={iconSearch} alt="Search" />
            <HeaderIcons src={iconLanguage} alt="Language" />
            <HeaderLanguageText>US | English</HeaderLanguageText>
          </HeaderActions>
        </>
      </HeaderContentWrapper>
    </HeaderDiv>
  )
}

export default Header
